module.exports = __webpack_public_path__ + "img/徐海宁.fc6ff5b5.png";